import type { ComponentType, ReactElement, ReactNode } from 'react';

import dynamic from 'next/dynamic';

import { useAppContext } from '~/utilities/context/static/AppContext';
import { SiteType } from '~/utilities/graphql/codegen';

/**
 * Per-brand styling is code-split: each site only downloads its own brand's
 * homepage CSS chunk (the shared scaffolding is deduped into a common chunk).
 * `ssr: true` keeps the wrapper server-rendered so critical CSS is still
 * extracted server-side — no FOUC.
 */
const Wrappers: Record<SiteType, ComponentType<{ children: ReactNode }>> = {
  [SiteType.Gstar]: dynamic(() => import('./HomepageWrapper.gstar.styles').then(m => m.Wrapper), {
    ssr: true,
  }),
  [SiteType.Outlet]: dynamic(() => import('./HomepageWrapper.gstar.styles').then(m => m.Wrapper), {
    ssr: true,
  }),
  [SiteType.Employeeshop]: dynamic(
    () => import('./HomepageWrapper.gstar.styles').then(m => m.Wrapper),
    { ssr: true }
  ),
  [SiteType.Wahts]: dynamic(() => import('./HomepageWrapper.wahts.styles').then(m => m.Wrapper), {
    ssr: true,
  }),
  [SiteType.Aaf]: dynamic(() => import('./HomepageWrapper.aaf.styles').then(m => m.Wrapper), {
    ssr: true,
  }),
};

export const HomepageWrapper = ({ children }: { children: ReactNode }): ReactElement => {
  const { siteType } = useAppContext();
  const Wrapper = Wrappers[siteType];

  return <Wrapper>{children}</Wrapper>;
};
